import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { GameStatistics } from '../../types';

interface WinRateChartProps {
  stats: GameStatistics;
}

interface PieLabelProps {
  name?: string;
  percent?: number;
}

const WinRateChart: React.FC<WinRateChartProps> = ({ stats }) => {
  const data = [
    { name: 'Won', value: stats.gamesWon },
    { name: 'Lost', value: stats.gamesLost },
  ];

  const COLORS = {
    Won: '#4caf50',
    Lost: '#f44336',
  };

  // Don't render if no games played
  if (stats.totalGames === 0) {
    return null;
  }

  const renderLabel = ({ name, percent }: PieLabelProps) => {
    if (!name || percent === undefined) return '';
    return `${name}: ${(percent * 100).toFixed(0)}%`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderLabel}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[entry.name as keyof typeof COLORS]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default WinRateChart;

